import { Common } from '@stockbit/ui';
import { ErrorText } from 'features/reset-password/styled';
import If from 'global/ErrorHandlers/If';
import useForm from 'hooks/useForm';
import Link from 'next/link';
import { useState } from 'react';
import { PasswordCancelButton, PasswordSubmitButton } from '../styled';
import changeEmailStore from './store';
import { WORDING_FORMAT_EMAIL_WRONG } from '../constants';

const { Flex, Text, Input } = Common;

interface NewEmailProps {
  email: string;
  onNext: () => void;
  cancelLink: string;
  onClickCancel?: () => void;
}

function NewEmail({
  email,
  onNext,
  cancelLink,
  onClickCancel = () => {},
}: NewEmailProps) {
  const [isLoading, changeToken, updateEmail] = changeEmailStore((s) => [
    s.isLoading,
    s.changeToken,
    s.updateEmail,
  ]);

  const [newEmail, setNewEmail] = useForm({});
  const [newEmailError, setNewEmailError] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (newEmailError) return false;

    const data = {
      change_token: changeToken,
      email: newEmail,
    };

    const res = await updateEmail(data);

    if (res?.data) {
      onNext();
      setNewEmail({ target: { value: '' } });
    }
  };

  const handleBlurEmail = () => {
    if (!newEmail.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/)) {
      setNewEmailError(WORDING_FORMAT_EMAIL_WRONG);
    } else {
      setNewEmailError('');
    }
    setNewEmail({ target: { value: newEmail.trim() } });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Flex
        padding="0 15px 20px 15px"
        width="100%"
        direction="column"
        margin="auto"
      >
        <Text size="16px" family="bold" mb="15px" height="1.5">
          Masukkan Alamat Email Baru Kamu
        </Text>
        <Flex align="center" width="100%" mb="10px">
          <Flex width="30%" align="center">
            <Text>Email Sekarang</Text>
          </Flex>
          <Text family="bold" data-cy="new-email-current-email">
            {email}
          </Text>
        </Flex>
        <Flex align="center" width="100%">
          <Flex width="30%" align="center">
            <Text>Email Baru</Text>
          </Flex>
          <Flex width="70%">
            <Input
              type="email"
              name="new-email"
              value={newEmail}
              onChange={setNewEmail}
              onBlur={handleBlurEmail}
              width="100%"
              data-cy="new-email-set-new-email-input-box"
            />
          </Flex>
        </Flex>
        <If condition={!!newEmailError}>
          <Flex align="center" width="100%" justify="flex-end">
            <Flex width="70%">
              <ErrorText mt="8px" data-cy="new-email-invalid-email-format">
                {newEmailError}
              </ErrorText>
            </Flex>
          </Flex>
        </If>
      </Flex>

      <Flex mt="10px">
        <Link href={cancelLink}>
          <PasswordCancelButton disabled={false} onClick={onClickCancel} data-cy="new-email-cancel-button">
            Cancel
          </PasswordCancelButton>
        </Link>
        <PasswordSubmitButton
          htmlType="submit"
          type="primary"
          loading={isLoading}
          onClick={handleSubmit}
          data-cy="new-email-submit-button"
        >
          Submit
        </PasswordSubmitButton>
      </Flex>
    </form>
  );
}

export default NewEmail;
